<div class="loader-container">
    <ion-icon src="./assets/icon/Loader.svg"></ion-icon>
</div>
